import React, { Suspense, useState } from 'react';
import { Menu, Layout, ChevronDown } from 'lucide-react';

// Importaciones usando React.lazy
const SeismicCalculator = React.lazy(() => import('../seismic-calc/App'));
const MuroMamposteria = React.lazy(() => import('../muro-mamposteria/App'));
const AppPortal = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeApp, setActiveApp] = useState('home');

  const apps = [
    { 
      id: 'seismic-calc', 
      name: 'EspectroRD', 
      description: 'Herramienta para análisis sísmicos',
      component: SeismicCalculator
    },
    { 
      id: 'muro-mamposteria', 
      name: 'Mampostería (R027)', 
      description: 'Cálculo y diseño de Muros de Mampostería',
      component: MuroMamposteria
    }
  ];

  const handleAppChange = (newApp) => {
    if (newApp === 'home') {
      setActiveApp(newApp);
      // Refrescar la página
      window.location.reload();
    } else {
      setActiveApp(newApp);
    }
  };

  const renderActiveApp = () => {
    const currentApp = apps.find(app => app.id === activeApp);
    if (currentApp?.component) {
      return (
        <Suspense fallback={
          <div className="flex items-center justify-center h-screen">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
              <p>Cargando aplicación...</p>
            </div>
          </div>
        }>
          <div className="w-full">
            <currentApp.component />
          </div>
        </Suspense>
      );
    }
    return null;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between h-16">
            <div className="flex items-center">
              <button 
                onClick={() => setMenuOpen(!menuOpen)}
                className="p-2 rounded-md hover:bg-gray-100 lg:hidden"
              >
                <Menu className="h-6 w-6" />
              </button>
             
            </div>

            <div className="hidden lg:flex lg:items-center lg:space-x-8">
              <button
                onClick={() => handleAppChange('home')}
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  activeApp === 'home'
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                Inicio
              </button>
              <div className="relative group">
                <button className="flex items-center space-x-1 px-3 py-2 rounded-md hover:bg-gray-100">
                  <span>Aplicaciones</span>
                  <ChevronDown className="h-4 w-4" />
                </button>
                <div className="absolute left-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                  {apps.map(app => (
                    <button
                      key={app.id}
                      onClick={() => handleAppChange(app.id)}
                      className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      {app.name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden">
            <div className="pt-2 pb-3 space-y-1">
              <button
                onClick={() => {
                  handleAppChange('home');
                  setMenuOpen(false);
                }}
                className={`block w-full text-left px-4 py-2 text-base font-medium ${
                  activeApp === 'home'
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                Inicio
              </button>
              {apps.map(app => (
                <button
                  key={app.id}
                  onClick={() => {
                    handleAppChange(app.id);
                    setMenuOpen(false);
                  }}
                  className={`block w-full text-left px-4 py-2 text-base font-medium ${
                    activeApp === app.id
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  {app.name}
                </button>
              ))}
            </div>
          </div>
        )}
      </nav>

      <main className="w-full mx-auto">
        {activeApp === 'home' ? (
          <div className="max-w-7xl mx-auto px-4 py-8">
            <div className="text-center">
              <h1 className="text-4xl font-bold text-gray-900 mb-8">Bienvenido</h1>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {apps.map(app => (
                  <div
                    key={app.id}
                    className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
                  >
                    <Layout className="h-12 w-12 text-blue-600 mx-auto mb-4" />
                    <h2 className="text-xl font-semibold mb-2">{app.name}</h2>
                    <p className="text-gray-600">{app.description}</p>
                    <button
                      onClick={() => handleAppChange(app.id)}
                      className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
                    >
                      Abrir Aplicación
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          renderActiveApp()
        )}
      </main>
    </div>
  );
};

export default AppPortal;